module.exports = __webpack_public_path__ + "img/5.adf6cea4.jpg";